import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "dtwin-map-instance",
    staticStyle: {
      "height": "100%",
      "width": "100%"
    }
  }, [_c('CoreMapboxMglMap', {
    key: `map_instance_${_vm.mapBoundsLockKey}`,
    ref: "twinMap",
    staticClass: "twinMap",
    attrs: {
      "bearing": _vm.realCamera.bearing,
      "zoom": _vm.realCamera.zoom,
      "center": _vm.realCamera.center,
      "minZoom": _vm.mapBoundsLock.length ? _vm.realCamera.zoom : undefined,
      "maxZoom": _vm.mapBoundsLock.length ? _vm.realCamera.zoom : undefined
    },
    on: {
      "load": _vm.onMapLoaded,
      "moveend": _vm.updateMarkers,
      "zoomend": _vm.updateMarkers
    }
  }, [_vm._l(_vm.markerItems, function (marker, i) {
    return _c('MglMarker', {
      key: `marker_${i}`,
      attrs: {
        "coordinates": marker.coordinates,
        "title": marker.title,
        "dtId": marker.id,
        "anchor": "bottom"
      },
      on: {
        "click": function ($event) {
          return _vm.selectMarker($event);
        }
      }
    }, [_c('MglPopup', {
      attrs: {
        "offset": _vm.markerPopupOffset,
        "onlyText": false
      },
      on: {
        "open": _vm.openPopup,
        "close": _vm.closeDtwinPopup
      }
    }, [[_c('div', {
      staticClass: "twinDetail"
    }, [_c('core-dtwin-detail-public-map', {
      attrs: {
        "dtwin": _vm.selectedMarkerItem && _vm.selectedMarkerItem.id && _vm.selectedMarkerItem.id === marker.id ? _vm.selectedMarkerItem : {},
        "baseLink": _vm.detailsBaseLink
      }
    })], 1)]], 2), _c('span', {
      staticStyle: {
        "z-index": "2"
      },
      attrs: {
        "slot": "marker"
      },
      slot: "marker"
    }, [_vm.markerStyle === 'outlined' || _vm.markerStyle === 'default' ? [_c('div', {
      class: _vm.markerHeadClasses,
      style: _vm.markerHeadStyle
    }, [marker.imageId ? [_c('img', {
      class: _vm.markerImageClass,
      attrs: {
        "src": _vm.mapMarkerIconUrl(marker.imageId)
      }
    })] : [_c(VIcon, {
      staticClass: "pmMglMarkerIcon",
      attrs: {
        "color": _vm.markerHeadIconColor
      }
    }, [_vm._v("\n                fal fa-" + _vm._s(marker.faIcon ? marker.faIcon : 'map-marker-alt') + "\n              ")])]], 2), _c('div', {
      class: _vm.markerWidthClass
    }, [_c('div', {
      class: _vm.markerLineClass,
      style: _vm.markerLineStyle
    })]), _c('div', {
      class: _vm.markerWidthClass
    }, [_c('div', {
      class: _vm.markerAnchorClass,
      style: _vm.markerAnchorStyle
    })])] : [marker.imageId ? [_c('div', {
      staticClass: "markerIcon",
      style: `background-image: url('${_vm.mapMarkerIconUrl(marker.imageId)}')`
    })] : [_c(VIcon, {
      staticClass: "markerPin",
      attrs: {
        "color": marker.color || _vm.color
      }
    }, [_vm._v("\n              fal fa-" + _vm._s(marker.faIcon ? marker.faIcon : 'map-marker-alt') + "\n            ")]), _c('span', {
      staticClass: "markerPinTitle",
      style: marker.color ? `color: ${marker.color}` : ''
    }, [_vm._v("\n              " + _vm._s(marker.title) + "\n            ")])]]], 2)], 1);
  }), _vm._l(_vm.clusters, function (cluster, i) {
    return _c('MglMarker', {
      key: `cluster_${i}`,
      attrs: {
        "coordinates": cluster.center,
        "title": cluster.count,
        "dtId": `cluster_${i}`,
        "anchor": 'center'
      },
      on: {
        "click": function ($event) {
          return _vm.zoomIntoCluster(cluster);
        }
      }
    }, [_c('span', {
      staticStyle: {
        "z-index": "2"
      },
      attrs: {
        "slot": "marker"
      },
      slot: "marker"
    }, [_c('div', {
      staticClass: "clusterMarker",
      style: `background-color: ${_vm.markerColor}; ${_vm.clusterIconSize(cluster.count)}`
    }, [_vm._v("\n          " + _vm._s(cluster.count) + "\n        ")])])]);
  }), _c('MglNavigationControl', {
    attrs: {
      "position": "bottom-right"
    }
  }), _c('MglGeolocateControl', {
    attrs: {
      "position": "bottom-right"
    }
  })], 2), _vm._t("bottom"), _vm.selectedCluster.items ? _c('core-n20Card', {
    staticClass: "pb-8 pa-2 dtwin-preview twinClusterDetail",
    staticStyle: {
      "z-index": "4"
    },
    scopedSlots: _vm._u([{
      key: "buttons",
      fn: function () {
        return [_c('core-button', {
          attrs: {
            "title": _vm.$i18n_t('Common.cancel'),
            "color": "danger",
            "prepend-icon": "fa-times"
          },
          on: {
            "click": function ($event) {
              return _vm.$emit('getClusterContent', null);
            }
          }
        })];
      },
      proxy: true
    }], null, false, 489683904)
  }, [_c(VSimpleTable, {
    staticClass: "mt-3 mx-0 pa-0 twinClusterDetailTable",
    scopedSlots: _vm._u([{
      key: "default",
      fn: function () {
        return [_c('tbody', _vm._l(_vm.selectedCluster.items, function (twin, i) {
          return _c('tr', {
            key: `twin_clustered_${i}`
          }, [_c('td', [_c(VIcon, {
            attrs: {
              "color": _vm.color,
              "title": _vm.$i18n_t('Common.viewDetails'),
              "small": ""
            },
            on: {
              "click": function ($event) {
                return _vm.markerItemClicked({
                  ...twin,
                  component: {
                    $attrs: {
                      dtId: twin.id,
                      title: twin.title
                    }
                  }
                });
              }
            }
          }, [_vm._v("\n                fal fa-eye\n              ")])], 1), _c('td', {
            staticStyle: {
              "vertical-align": "middle"
            }
          }, [_c('p', {
            staticClass: "my-0"
          }, [_vm._v(_vm._s(twin.title))])])]);
        }), 0)];
      },
      proxy: true
    }], null, false, 3580520337)
  })], 1) : _vm._e()], 2);
};
var staticRenderFns = [];
export { render, staticRenderFns };